






















import { Component, BaseComponent } from '@/component';
import { Action } from '@/store/actions';
import { zipToProject } from '@/services/zip';

@Component({})
export default class Import extends BaseComponent {
	$refs!: {
		files: HTMLInputElement;
	};

	async importWidget() {
		if (this.$refs.files.files && this.$refs.files.files[0]) {
			const file = this.$refs.files.files[0];
			const reader = new FileReader();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			reader.addEventListener('load', async (event: any) => {
				const blob = event.target.result;
				const project = await zipToProject(blob);

				this.$store.dispatch<Action>({
					type: 'importProject',
					project: project
				});

				alert(`Sucessfully imported "${project.meta.name}"`);
				this.$router.push('/');
			});
			reader.readAsArrayBuffer(file);
		}
	}
}
